import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//For Form controls
import { MatCheckboxModule } from '@angular/material';
import { MatButtonModule } from '@angular/material';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MatFormFieldModule } from '@angular/material/form-field';//group mat components and give same style to all of them
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';//drag a play
import { MatSlideToggleModule } from '@angular/material/slide-toggle';//ON/OFF

//For Navigation
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';//header on the top of screen

//For Layout
import { MatListModule } from '@angular/material/list';//several list types
import { MatGridListModule } from '@angular/material/grid-list';//gridview
import { MatCardModule } from '@angular/material/card';//insert photos, text in a card
import { MatStepperModule } from '@angular/material/stepper';//performing steps to complete process
import { MatTabsModule } from '@angular/material/tabs';//select between sub screens
import { MatExpansionModule } from '@angular/material/expansion';//expand to different sections
import { MatDividerModule } from '@angular/material/divider';//line drawn between as a separator
import { MatTreeModule } from '@angular/material/tree';//Expanding menu

//Buttons and Indicators
import { MatButtonToggleModule } from '@angular/material/button-toggle';//ON/OFF between two or more buttons
import { MatChipsModule } from '@angular/material/chips';//similar to tabs converted to separate buttons. Can be used as multiple inputs under autocomplete
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';//Icon pointer
import { DomSanitizer } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';//Loading circle
import { MatProgressBarModule } from '@angular/material/progress-bar';//Processing line
import { MatBadgeModule } from '@angular/material/badge';//Round on top with number inside, for ex: num of notifications over button, label, etc

//Popups and modals
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';//Notifications at the bottom
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';//Used as alternate to Dialogs and Menu in Mobile screen
import { MatRippleModule } from '@angular/material/core';

//DataTable
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';

import { CdkTableModule } from '@angular/cdk/table';

import { FlexLayoutModule } from '@angular/flex-layout';

import { environment } from 'src/environments/environment';

@NgModule({
  imports: [
    CommonModule,

    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatDividerModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBadgeModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatBottomSheetModule,
    MatRippleModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,

    CdkTableModule,

    FlexLayoutModule,
  ],
  exports: [
    CommonModule,

    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatDividerModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBadgeModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatBottomSheetModule,
    MatRippleModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,

    CdkTableModule,

    FlexLayoutModule,
  ],
  //https://stackoverflow.com/questions/47270324/nullinjectorerror-no-provider-for-matdialogref
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    },
  ],
  declarations: []
})
export class MaterialModule {
  assetsPath: string;
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    this.assetsPath = environment.assetsPath;
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('/Webviewer/assets/svg/mdi.svg')); // Or whatever path you placed mdi.svg at
    //https://www.positronx.io/angular-material-8-icons-tutorial-with-real-world-examples/
    //https://css-tricks.com/scale-svg/
    matIconRegistry.addSvgIcon('OOS', domSanitizer.bypassSecurityTrustResourceUrl('/Webviewer/assets/svg/Line_within_circle.svg'));
    //matIconRegistry.addSvgIcon('stat1', domSanitizer.bypassSecurityTrustResourceUrl('../../assets/svg/stat1.svg'));
    //matIconRegistry.addSvgIcon('report', domSanitizer.bypassSecurityTrustResourceUrl('../../assets/svg/report.svg'));
    //matIconRegistry.addSvgIcon('console', domSanitizer.bypassSecurityTrustResourceUrl('../../assets/svg/console.svg'));
    //matIconRegistry.addSvgIcon('calendar-schedule', domSanitizer.bypassSecurityTrustResourceUrl('../../assets/svg/calendar-schedule.svg'));
    //matIconRegistry.addSvgIcon('search-results', domSanitizer.bypassSecurityTrustResourceUrl('../../assets/svg/search-results.svg'));
  }
}
